import { CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts'
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import { Fragment, ReactNode } from 'react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import Card from 'app/frontend/base/components/Card'
import { cn } from '@/lib/utils'

type Props = {
  config: ChartConfig
  values: { label: string; total: number }[]
  compact?: boolean
  title?: string
}

const AuditGraph = ({ config, values, compact, title }: Props) => {
  const {
    data: { currentSeason },
  } = usePageInfo()

  const Wrapper = compact ? Fragment : Card
  const wrapperProps = compact ? {} : { className: 'mt-2' }

  return (
    <Wrapper
      {...(wrapperProps as { className?: string; children?: ReactNode })}
    >
      <p
        className={cn(
          'text-sm text-muted-foreground font-medium text-center',
          compact ? 'mb-2' : 'mb-4',
        )}
      >
        {title ??
          `Weekly keystone dungeons completed in ${currentSeason?.name}`}
      </p>

      <ChartContainer
        config={config}
        className={cn('w-full', compact ? 'max-h-[200px]' : 'max-h-[400px]')}
      >
        <LineChart
          accessibilityLayer
          data={values}
          margin={{ top: 10, right: 12, bottom: 20 }}
        >
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey='label'
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            tick={compact ? { fontSize: 14 } : undefined}
            label={{
              value: 'Week in season',
              position: 'insideBottom',
              offset: -20,
              style: compact ? { fontSize: 14 } : undefined,
            }}
          />
          <ChartTooltip content={<ChartTooltipContent hideLabel />} />
          <YAxis
            dataKey='total'
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            width={30}
            tick={compact ? { fontSize: 14 } : undefined}
          />
          <Line
            dataKey='total'
            type='linear'
            stroke='var(--color-total)'
            strokeWidth={2}
            dot={false}
            animationDuration={750}
          />
        </LineChart>
      </ChartContainer>
    </Wrapper>
  )
}

export default AuditGraph
